import { Stack as ChakraStack, forwardRef, StackProps } from '@chakra-ui/react';

/**
 Stack is a layout component used to group elements together and apply a space between them.
 */
export const Stack = forwardRef((props: StackProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraStack ref={ref} {...otherProps}>
      {children}
    </ChakraStack>
  );
});

export { HStack, VStack, StackDivider } from '@chakra-ui/react';
